<template>
    <div>
        <!-- <headLine></headLine> -->
        <div class="elder_manage_title">
            <p class="title">学习培训</p>
        </div>
        <slot name="statistics"></slot>
        <div class="search_wrapper">
            <div class="search_head">
                <span>查询条件</span>
                <!-- <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="Reset"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button> -->
                <i
                    class="searchDomw"
                    @click="isSearchContent = !isSearchContent"
                    :class="
                        isSearchContent == true
                            ? 'el-icon-arrow-up'
                            : 'el-icon-arrow-down'
                    "
                ></i>
            </div>
            <div class="search_content" v-show="isSearchContent">
                <div class="search_inline">
                    <el-form label-width="120px">
                        <el-row>
                            <el-col :span="6">
                                <el-form-item label="名称：">
                                    <el-input
                                        clearable
                                        placeholder="请输入"
                                        v-model="searchObj.typeName"
                                        size="primary"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3" :offset="2">
                                <el-button
                                    type="primary"
                                    size="medium"
                                    class="searchBtns"
                                    @click="query"
                                    >查询</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div> -->
            </div>
        </div>

        <el-button
            icon="el-icon-plus"
            class="openBtns"
            style="margin: 10px 0"
            type="success"
            size="medium"
            @click="showDialog('新增')"
        >
            新增
        </el-button>

        <el-table
            :data="tableData"
            border
            style="width: 100%; margin-bottom: 15px"
            ref="addForm"
            :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
        >
            <el-table-column
                type="index"
                width="70"
                label="序号"
                align="center"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                prop="typeName"
                label="名称"
                align="center"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                prop="type"
                label="类型"
                align="center"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span
                        v-for="(item, index) in typeList"
                        :key="index"
                        v-if="scope.row.type == item.id"
                        >{{ item.label }}</span
                    >
                </template>
            </el-table-column>
            <el-table-column
                prop="orgName"
                label="区域"
                align="center"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                prop="enclosure"
                label="附件"
                align="center"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column label="操作" align="center" width="150">
                <template slot-scope="scope">
                    <el-button
                        @click="showDialog('查看', scope.row)"
                        type="text"
                        >查看</el-button
                    >
                    <el-button
                        @click="showDialog('编辑', scope.row)"
                        type="text"
                        >编辑</el-button
                    >
                    <el-button @click="deleteItem(scope.row.id)" type="text"
                        >删除</el-button
                    >
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageConfig.pageNo"
            :page-sizes="[5, 10, 20, 50]"
            :page-size="pageConfig.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pageConfig.total"
        >
        </el-pagination>

        <!-- 表单弹框-->
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogVisible"
            width="500px"
            :close-on-click-modal="false"
            :before-close="handleClose"
        >
            <el-form
                :disabled="dialogTitle === '查看'"
                :model="addForm"
                :rules="rules"
                ref="addForm"
                label-width="90px"
            >
                <el-form-item label="名称:" prop="typeName">
                    <el-input
                        v-model="addForm.typeName"
                        placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item label="类型:" prop="type">
                    <el-select v-model="addForm.type" style="width: 100%">
                        <el-option
                            v-for="(item, index) in typeList"
                            :key="index"
                            :value="item.id"
                            :label="item.label"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="接口文档:" prop="enclosure">
                    <el-upload
                        class="upload-demo"
                        :action="actionUrl"
                        multiple
                        :on-preview="handlePreview"
                        :on-success="handleEnclosureSuccess"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        :on-exceed="handleExceed"
                        :file-list="fileList"
                        :limit="1"
                    >
                        <el-button
                            style="color: #1c84c6; border: 1px solid #1c84c6"
                            >点击上传</el-button
                        >
                    </el-upload>
                </el-form-item>
            </el-form>
            <div
                v-if="dialogTitle !== '查看'"
                style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    margin-top: 15px;
                "
            >
                <el-button @click="send" type="primary">确定</el-button>
                <el-button @click="handleClose" type="info">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import globalTag from "../components/globalTag"
import headLine from "../components/headline"
import baseURL from "@/api/baseURL"

export default {
    components: {
        globalTag,
        headLine,
    },
    data() {
        return {
            searchObj: {
                serviceTypeId: "",
                name: "",
            },
            dialogTitle: "",
            dialogVisible: false,
            editId: "",
            addForm: {
                typeName: "",
                enclosure: "",
            },
            rules: {
                typeName: [
                    {
                        required: true,
                        message: "请输入名称",
                        trigger: "blur",
                    },
                ],
                type: [
                    {
                        required: true,
                        message: "请输入类型",
                        trigger: "blur",
                    },
                ],
                enclosure: [
                    { required: true, message: "请选择f附件", trigger: "blur" },
                ],
            },
            tableData: [],
            // 分页
            pageConfig: {
                pageNo: 1,
                pageSize: 10,
                total: 0,
            },
            typeList: [
                { id: "0", label: "通知公告" },
                { id: "1", label: "绩效评估" },
                { id: "2", label: "学习资料" },
                { id: "3", label: "报表填写" },
                { id: "4", label: "操作手册" },
            ],
            isSearchContent: true,
            actionUrl: "",
            fileList: [],
            typetitle: "",
        }
    },
    created() {
        this.getTableData()
        this.actionUrl =
            baseURL + "/ypt/controller/uploadController/info/uploadPhoto"
    },
    methods: {
        // 搜索
        query() {
            this.pageConfig.pageNo = 1
            this.getTableData()
        },
        Reset() {
            this.searchObj = {}
            this.getTableData()
        },
        //上传附件
        handlePreview(res, file, fileList) {
            this.$set(this.addForm, "enclosure", res.content)
            if (this.dialogTitle != "新增") {
                window.open(res.name)
            }
        },
        handleRemove(file, fileList) {},
        handleExceed(files, fileList) {
            this.$message.warning(
                `当前限制只可上传 1 个文件，本次选择了 ${files.length} 个文件，`
            )
        },
        beforeRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`)
        },
        // 附件上传
        handleEnclosureSuccess(res, file, fileList) {
            let arrs = []
            let cont = []
            //  console.log(res, file,fileList,"0000")
            fileList.forEach((element) => {
                // arrs.push(element.name)
                // if (element && element.response && element.response.content) {
                //     cont.push(element.response.content)
                // }
                //this.formData.enclosure = element.name
                this.addForm.enclosure = element.response.content
                this.$forceUpdate()
            })
        },

        // 提交
        send() {
            this.$refs.addForm.validate((valid) => {
                // 校验通过
                if (valid) {
                    let data = {
                        ...this.addForm,
                    }
                    const loading = this.$loading({
                        lock: true,
                        text: "Loading",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)",
                    })
                    this.$http
                        .request({
                            url: "/jjyl/admin/learningtraining/info/insertOrUpdate",
                            method: "POST",
                            data: data,
                        })
                        .then((res) => {
                            if (res.code == 200) {
                                loading.close()
                                this.$message.success("操作成功")
                                this.handleClose()
                                this.getTableData()
                            }else{
                                loading.close()
                            }
                        }).catch((error) => {
                            loading.close()
                            this.handleClose()
                        })
                }
            })
        },
        // 删除某一项
        deleteItem(id) {
            this.$confirm("此操作将删除该数据, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http
                    .request({
                        url: "/jjyl/admin/learningtraining/info/deleteById",
                        method: "POST",
                        data: {
                            id,
                        },
                    })
                    .then((res) => {
                        if (res.code == 200) {
                            this.$message.success("删除成功")
                            this.getTableData()
                        }
                    })
            })
        },
        // 显示弹框
        showDialog(title, row) {
            this.dialogTitle = title
            this.dialogVisible = true
            console.log(row)
            if (title != "新增") {
                this.addForm = {
                    typeName: row.typeName,
                    enclosure: row.enclosure,
                    id: row.id,
                    type: row.type,
                }
                this.fileList.push({
                    name: this.addForm.enclosure,
                })
            } else {
                this.addForm = {
                    typeName: "",
                    enclosure: "",
                }
                this.fileList = []
            }
        },
        // 关闭弹框
        handleClose() {
            this.dialogVisible = false
            this.$refs.addForm.resetFields()
            this.fileList = []
        },

        // 获取列表数据
        getTableData() {
            this.$http
                .request({
                    url: "/jjyl/admin/learningtraining/info/findList",
                    method: "POST",
                    data: {
                        pageNo: this.pageConfig.pageNo,
                        pageSize: this.pageConfig.pageSize,
                        typeName: this.searchObj.typeName,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (!res.content) {
                            this.tableData = []
                            this.pageConfig.total = 0
                        } else {
                            this.tableData = res.content.list || []
                            this.pageConfig.total = res.content.count || 0
                        }
                    }
                })
        },
        // 每页显示条数切换
        handleSizeChange(val) {
            this.pageConfig.pageSize = val
            this.getTableData()
        },
        // 页码切换
        handleCurrentChange(val) {
            this.pageConfig.pageNo = val
            this.getTableData()
        },
    },
}
</script>

<style lang="less" scoped>
/deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    width: 100px;
    cursor: pointer;
    position: relative;
    overflow: hidden;

    .avatar-uploader .el-upload:hover {
        border-color: #409eff;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
    }

    .avatar {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;

        img {
            width: 100px;
            height: 100px;
            line-height: 100px;
            display: block;
        }
    }
}
.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }
    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}
/deep/ .search_wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    background: #f1f2f6;
    box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
    overflow: hidden;
    border-radius: 4px;
    .search_head {
        background: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: rgb(0, 0, 0);
        border-color: rgb(217, 217, 217);
        padding: 6px 15px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .search_content {
        padding: 15px 20px 0px 5px;
        border: 1px solid rgb(217, 217, 217);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .search_inline {
        width: 100%;
    }
    .arrowDown {
        width: 28px;
        height: 28px;
        background: #edf2f0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 50%;
        bottom: -14px;
        transform: translate(-50%, 0px);
        border-radius: 50%;
        z-index: 2;
        cursor: pointer;
    }
}
.searchDomw {
    cursor: pointer;
}
/deep/.el-input__suffix {
    margin-top: 0;
}
</style>
